import React from 'react';
import FilterDropdownField from '../../../../../shared/ui/FilterDropdownField/FilterDropdownField';

const RelatedPersons = ({ configs }) => {
  return (
    <div>
      {configs?.map((config, index) => (
        <FilterDropdownField
          key={index}
          config={config}
        />
      ))}
    </div>
  );
};

export default RelatedPersons;
